<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import FullCalendar from "@/Components/Admin/Calendar/FullCalendar.vue";

defineProps({
  users: Array,
});
</script>

<template>
  <AppLayout title="Office Calendar">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Office Calendar
      </h2>
    </template>

    <div>
      <div class="mx-auto py-10 sm:px-6 lg:px-8">
        <FullCalendar :users="users"></FullCalendar>
      </div>
    </div>
  </AppLayout>
</template>
